<nav class="navbar navbar-expand-lg fixed-top navbar-light bg-white p-0 qai-navbar">
    <div class="container-fluid ps-0">
        <a class="navbar-brand p-0 tim-logo" href="/admin/">
            <img src="images/TIMAISearchLogo_white.png" alt="Tim Enterprice Logo" class="py-4" width="200px" />
        </a>
        <div class="collapse navbar-collapse" id="navbarText">
            <ul class="navbar-nav me-auto mb-2 mb-lg-0">
                <li class="nav-item">
                    <a class="nav-link active qai-header-nav-link" aria-current="page" href="#">{{ routeData?.title ||
                        'Search Admin Console' }}</a>
                </li>
            </ul>
            @if (authSrv.isLoggedIn()()) {

            @let tokenInfo = authSrv.tokenInfo()();

            <div ngbDropdown>
                <div class="d-flex align-items-center justify-content-center qai-user-info" id="userDropDown"
                    role="button" ngbDropdownToggle>
                    <div class="p-2 qai-avatar text-center bg-primary">
                        <span alt="Avatar">
                            @if (demoMode) {
                            DU
                            } @else {
                            {{ tokenInfo?.name?.charAt(0) }}{{ tokenInfo?.surname?.charAt(0) }}
                            }
                        </span>
                    </div>
                    <div class="p-2">
                        @if (demoMode) {
                        {{ tokenInfo?.role === 'ROLE_MAD' ? 'Demo User - MAD' : 'Demo User - ADM' }}
                        } @else {
                        {{ tokenInfo?.name }} {{ tokenInfo?.surname }}
                        }
                    </div>
                </div>

                <div ngbDropdownMenu aria-labelledby="userDropDown" class="pb-0 dropdown-menu-end">
                    <h6 class="dropdown-header border-bottom pb-3" style="line-height: 0.8em;">
                        @if (!demoMode) {
                        {{ tokenInfo?.email }}
                        <br />
                        <br />
                        }
                        Ruolo: {{ tokenInfo?.role === 'ROLE_MAD' ? 'Master Admin' : 'Admin' }}
                    </h6>
                    <button class="px-2 p-3" ngbDropdownItem [routerLink]="['/license']"
                        *ngxPermissionsOnly="['ROLE_MAD']"><fa-icon class="px-2"
                            [icon]="faFileContract"></fa-icon>Dettagli Licenza</button>
                    <button class="px-2 p-3" ngbDropdownItem [routerLink]="['/auth/change-password']"><fa-icon
                            class="px-2" [icon]="faKey"></fa-icon>Modifica Password</button>
                    <button class="px-2 p-3" ngbDropdownItem [routerLink]="['/auth/login']"><fa-icon class="px-2"
                            [icon]="faArrowRightFromBracket"></fa-icon>Logout</button>
                </div>
            </div>
            }
        </div>
    </div>
</nav>